import React from 'react';
import { Link } from 'react-router-dom';
import { FaCalendarAlt, FaClock, FaMapMarkerAlt, FaArrowRight, FaUsers } from 'react-icons/fa';
import './Events.css';
import { Helmet } from 'react-helmet';

const Events = () => {
  const upcomingEvents = [
    {
      id: 1,
      title: 'Annual Badminton Championship',
      date: 'January 15-17, 2026',
      time: '8:00 AM - 6:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Tournament',
      description: 'Our Annual Badminton Championship is one of the most anticipated events of the year. Players from different age groups and skill levels compete in a professionally organized tournament environment. This event helps players gain match experience, improve confidence, and showcase their progress in front of coaches, parents, and peers.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=600',
    },
    {
      id: 2,
      title: 'Winter Training Camp',
      date: 'January 20-25, 2026',
      time: '6:00 AM - 12:00 PM',
      location: 'Inter-Academy Friendly Matches',
      type: 'Training Camp',
      description: 'We organize friendly matches with other badminton academies to provide players with exposure to different playing styles. These matches help players understand competitive pressure, improve adaptability, and learn sportsmanship in a healthy competitive atmosphere.',
      image: 'https://images.unsplash.com/photo-1599391398131-cd12dfc6c24e?w=600',
      spots: '30 spots available',
      fee: '₹8,000 all inclusive'
    },
    {
      id: 3,
      title: 'In-House League Matches',
      date: 'February 2, 2026',
      time: '9:00 AM - 1:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Fun Event',
      description: 'In-house league matches are conducted exclusively for academy players. These events encourage internal competition, teamwork, and performance improvement. Players are grouped into teams, creating an exciting league-style experience that boosts motivation and consistency.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '50 families',
      fee: 'Free for members'
    },
    {
      id: 4,
      title: 'Beginners Skill Development Day',
      date: 'February 15, 2026',
      time: '4:00 PM - 7:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Workshop',
      description: 'This special event is designed for beginner-level players to help them gain confidence and improve basic skills. Coaches conduct focused sessions on grip, footwork, strokes, and game rules in a fun and encouraging environment, making learning enjoyable and effective.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '40 spots available',
      fee: '₹1,500 per person'
    },
    {
      id: 5,
      title: 'Youth Talent Identification Program',
      date: 'March 15, 2026',
      time: '4:00 PM - 7:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Workshop',
      description: 'Imperial Badminton Academy organizes talent identification events to recognize young and promising players. Through structured drills and match play, coaches assess skills, coordination, and potential, helping guide players toward long-term development pathways.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '40 spots available',
      fee: '₹1,500 per person'
    },
    {
      id: 6,
      title: 'Fitness & Conditioning Camp',
      date: 'March 25, 2026',
      time: '4:00 PM - 7:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Workshop',
      description: 'This event focuses on physical fitness essential for badminton performance. Players participate in strength training, agility drills, endurance exercises, and flexibility routines. The camp helps players improve stamina, speed, and injury prevention techniques.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '40 spots available',
      fee: '₹1,500 per person'
    },
    {
      id: 7,
      title: 'Tournament Preparation Camp',
      date: 'April 05, 2026',
      time: '4:00 PM - 7:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Workshop',
      description: 'Before major competitions, we conduct special tournament preparation camps. These camps include match simulations, strategy planning, mental training, and fitness conditioning to ensure players are fully prepared for competitive challenges.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '40 spots available',
      fee: '₹1,500 per person'
    },
    {
      id: 8,
      title: 'Coaching Workshops & Training Clinics',
      date: 'April 22, 2026',
      time: '4:00 PM - 7:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Workshop',
      description: 'We regularly host coaching workshops and training clinics to enhance technical understanding and game awareness. These sessions focus on advanced techniques, tactical play, and modern training methods, benefiting both players and aspiring coaches.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '40 spots available',
      fee: '₹1,500 per person'
    },
    {
      id: 9,
      title: 'Parent–Player Interaction & Feedback Sessions',
      date: 'May 02, 2026',
      time: '4:00 PM - 7:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Workshop',
      description: 'These events encourage open communication between coaches, players, and parents. Progress updates, performance discussions, and future training plans are shared, creating transparency and trust while aligning goals for player development.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '40 spots available',
      fee: '₹1,500 per person'
    },
    {
      id: 10,
      title: 'Awards & Achievement Recognition Ceremony',
      date: 'May 27, 2026',
      time: '4:00 PM - 7:00 PM',
      location: 'Imperial Badminton Academy',
      type: 'Workshop',
      description: 'To celebrate hard work and dedication, Imperial Badminton Academy organizes award ceremonies recognizing outstanding performance, discipline, improvement, and sportsmanship. These events motivate players and reinforce positive values.',
      image: 'https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600',
      spots: '40 spots available',
      fee: '₹1,500 per person'
    },
  ];

  return (
    <>
      <Helmet>
        <title>Events</title>
      </Helmet>
      <div className="events-page">
        <div className="page-header">
          <div className="container">
            <h1>Events & News</h1>
            <div className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <span>Events & News</span>
            </div>
          </div>
        </div>

        <section className="upcoming-events section">
          <div className="container">
            <div className="section-title">
              <h2>Upcoming Events</h2>
              <p>
                Don't miss out on exciting tournaments, training camps, and special events at Imperial.
              </p>
            </div>
            <div className="events-grid">
              {upcomingEvents.map((event) => (
                <div key={event.id} className="event-card">
                  <div className="event-image">
                    <img src={event.image} alt={event.title} />
                  </div>
                  <div className="event-content">
                    <h3>{event.title}</h3>
                    <div className="event-details">
                      <span><FaCalendarAlt /> {event.date}</span>
                      <span><FaClock /> {event.time}</span>
                    </div>
                    <p>{event.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="events-cta section bg-light">
          <div className="container">
            <div className="cta-box">
              <h2>Want to Host an Event at Imperial?</h2>
              <p>
                Our world-class facilities are available for tournaments, corporate events,
                and private functions. Get in touch to discuss your requirements.
              </p>
              <div className="cta-buttons">
                <Link to="/contact" className="btn btn-accent">
                  Contact Us <FaArrowRight />
                </Link>
                <Link to="/services/facilities" className="btn btn-secondary">
                  View Facilities
                </Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Events;
